export default __webpack_public_path__ + "static/media/philosophy.bfbba9a0.jpg";